import { Card, Col, Row } from 'antd';
import { ReactComponent as BackIcon } from 'assets/icons/back.svg';
import { SH } from 'common/components';
import configurationStore from 'common/stores/configuration/configuration.store';
import './gate-management.scss';
import { IGateConfiguration } from 'common/services/configuration-service/configuration.service.types';
import { GateManagementInstructions, GateReaderOptions, GateRelayOptions } from 'common/components/gate-controls/gate-control-options';
import { useGateControls } from 'common/components/gate-controls/use-gate-controls';
import { Fragment } from 'react';

export const GateManagement = () => {
  const controls = useGateControls();

  const getAdditionalGates = () => {
    return configurationStore.configuration?.gates.filter((i) => i.name != configurationStore.currentUserGate?.name && i.useGateController);
  };

  const getGateOptionsSection = (gate: IGateConfiguration) => {
    if (!gate.readers) {
      return <></>;
    }

    return (
      <div>
        <GateReaderOptions gate={gate} controls={controls} nameTag="h1" />
      </div>
    );
  };

  const getGates = () => {
    return configurationStore.configuration?.gates;
  };

  return (
    <div className="eiq-secure-traffic-page">
      <Row gutter={16}>
        <Col className="page-header">
          <SH.HotkeyLink
            to="/eiq-secure"
            className="go-back"
            label={
              <>
                <BackIcon />
                <span>Home</span>
              </>
            }
          />
        </Col>
      </Row>
      <Row gutter={16} className="traffic-content">
        <Col flex="auto">
          <Card className="eiq-card eiq-card-border gate-controller" style={{ width: '100%' }}>
            <div className="description">
              <h1 className="h1 title">GATE MANAGEMENT</h1>
              <GateManagementInstructions />
            </div>

            {!!configurationStore.currentUserGate?.useGateController && (
              <div className="gates description">
                <h1 className="h1 doors">Doors</h1>

                {getGateOptionsSection(configurationStore.currentUserGate)}
                {!!getAdditionalGates() &&
                  getAdditionalGates()?.map((gate, index) => (
                    <Fragment key={`${gate.panelNumber}:${gate.name}:${index}`}>{getGateOptionsSection(gate)}</Fragment>
                  ))}
              </div>
            )}

            {!!getGates()?.flatMap((i) => i.relays ?? []).length && (
              <div className="gates description">
                <h1 className="h1 doors">Relays</h1>
                {getGates()?.map((gate, index) => (
                  <GateRelayOptions key={`${gate.panelNumber}:${gate.name}:${index}`} gate={gate} controls={controls} nameTag="h1" />
                ))}
              </div>
            )}
          </Card>
        </Col>
      </Row>
    </div>
  );
};
